import React, { ChangeEvent, useRef, useState } from 'react';
import { ICartItem } from '../../../interfaces';
import Preloader from '../../../../../../ui/svg/common/preloader';
import { enableDisableCartItem } from '../../../data/data-service';
import { getLocalData } from '../../../domain/shopping-cart-address-provider';
import { rootActions, useAppDispatch } from '../../../data/store';

interface IEnableDisableCheckbox {
    cartItem: ICartItem,
}

const EnableDisableCheckbox = (props: IEnableDisableCheckbox) => {

    const { cartItem } = props;
    const [loading, setLoading] = useState(false);

    const dispatch = useAppDispatch();

    const toggleRef = useRef<HTMLInputElement>(null);

    const onToggle = async (_evt: ChangeEvent<HTMLInputElement>) => {

        setLoading(true);
        const response = await enableDisableCartItem(cartItem.cartItemGUID, getLocalData());
        setLoading(false);

        if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) return;

        dispatch(
            rootActions.setCartData(response.data.relatedData)
        );

        toggleRef?.current?.focus();
    };

    return (
        <>
            {
                !loading &&
                <label>
                    <input
                        aria-label={ cartItem.skuName }
                        ref={ toggleRef }
                        type="checkbox"
                        checked={ cartItem.isActive }
                        onChange={ onToggle }
                    />
                    <span className="sr-only">Enable or disable { cartItem.skuName }</span>
                </label>
            }

            {
                loading &&
                <Preloader width="15px" height="15px" color="#4f4f4f" />
            }
        </>
    )
};

export default EnableDisableCheckbox;